import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { SlickCarouselModule } from "ngx-slick-carousel";

import { SearchComponent } from "../search/search.component";
import { GetcardComponent } from "../getcard/getcard.component";
import { AccordianComponent } from "../accordian/accordian.component";
import { CategoryComponent } from "../category/category.component";

@NgModule({
  declarations: [
    SearchComponent,
    GetcardComponent,
    AccordianComponent,
    CategoryComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SlickCarouselModule,
  ],
  exports: [
    SearchComponent,
    GetcardComponent,
    AccordianComponent,
    CategoryComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SlickCarouselModule,
  ],
})
export class SharedModule {}
